;(function ($) {
    'use strict';
    $(document).ready(function () {

        $('.search-form').each(function () {
            var $form = $(this),
                $filters = $form.find('.filters select'),
                // Get Titles, values and names from each filter
                filtersVars = function () {
                    var values = {};
                    $filters.each(function () {
                        var $self = $(this),
                            nn = $self.get(0).nodeName.toLowerCase();
                        if ($self.attr('name') !== undefined) {
                            values[$self.attr('name')] = {
                                value: $self.val() || 0,
                                text: nn === 'select' ? $self.find(':selected').text() : $self.text(),
                                name: $self.attr('name'),
                                node: nn
                            };
                        }
                    });
                    return values;
                },
                // Remove the Post count from the titles
                cleanText = function (text) {
                    return text.replace(/\s*\([0-9,]+\)$/, '');
                },
                handleButton = function () {

//					$( 'input[id=sort_results_date]' ).click();

                    var $button = $(this),
                        name = $button.data('name');

                    // Reset a very specific one to 0
                    $filters
                        .filter('[name="' + name + '"]')
                        .val(0)
                        .trigger('change');

                },
                handleButtonAndClear = function () {
                    $('input[id=search_query_string]').val('');
                    console.log('ciao1');
                    // Reset all filters back to 0

                    $filters
                        .val(0)
                        .trigger('change');
                    console.log('ciao');
                },
                $buttonBox = $('<div class="button-box"></div>'),
                $clearButton = $('<div class="button clear-all filter-button">Clear search</div>'),
                addButtons = function () {
                    // Get the current filter vars
                    var _tmp = filtersVars();

                    // There are no filters so there's nothing to do
                    if (Object.keys(_tmp).length === 0) {
                        return;
                    }

                    // Button container
                    if ($form.find($buttonBox).length === 0) {
                        $buttonBox.appendTo($form);
                    }

                    // Remove any button hanging around
                    $buttonBox.find('.filter-button').off().remove();

                    // Add a button to clear filters if any are set
                    for (var i in _tmp) {
                        if (!_tmp.hasOwnProperty(i) || parseInt(_tmp[i].value, 10) <= 0) {
                            continue;
                        }

                        // Add the clear all button if we can't find one.
                        if ($buttonBox.find($clearButton).length === 0) {
                            $clearButton
                                .data({name: 'clear-all'})
                                .on('click', handleButtonAndClear)
                                .appendTo($buttonBox);
                        }

                        // Add a button for this filter
                        $('<div class="button filter-button">' + cleanText(_tmp[i].text) + '</div>')
                            .data({name: _tmp[i].name})
                            .on('click', handleButton)
                            .appendTo($buttonBox);
                    }

                },
                timer;

            addButtons();
            // Any change to the filters should submit the form
            $form.on('change', '.filters select, input[name=sort_results]', function (e) {
                addButtons();
                clearTimeout(timer);

                e.preventDefault();

                // Spin the spinner.
                $form
                    .find('.icon-magnification')
                    .first()
                    .addClass('search-loading');

                // Wait half a second before submitting to give users long enough to make more changes
                timer = setTimeout(function () {

                    // This just breaks things.. Disabling the buttons before submit just results in them have a null value for the submit.
//					var filters = document.getElementsByClassName( 'postform' );
//					for ( var i = 0; i < filters.length; i++ ) {
//						filters[ i ].disabled = true;
//					}
//					searchButton.disabled = true;
                    $form.submit();
                }, 500);
            });

            function delay(callback, ms) {
                var timer = 0;
                return function () {
                    var context = this, args = arguments;
                    clearTimeout(timer);
                    timer = setTimeout(function () {
                        callback.apply(context, args);
                    }, ms || 0);
                };
            }

            function checkSearchQuery(e) {
                if ($buttonBox.find($clearButton).length === 0 && $('input[id=search_query_string]').val()
                    .trim()) {
                    $clearButton
                        .data({name: 'clear-all'})
                        .on('click', handleButtonAndClear)
                        .appendTo($buttonBox);
                }
            }

            var inputSearch = $('input[id=search_query_string]');

            if (inputSearch.val() !== undefined) {
                inputSearch.keyup(
                    delay(checkSearchQuery, 600)
                );

                checkSearchQuery();
            }

        });
    });
}(jQuery));
